import { createContext, useContext, useEffect, useRef } from 'react';
import { isEmptyInputValue } from '../services/prehydration-values';
import { useFieldPropsV2 } from './field-props-context';
export const PrehydrationValuesContext = /*#__PURE__*/ createContext(undefined);
export const useKeepPrehydrationValue = (ref)=>{
    const registry = useContext(PrehydrationValuesContext);
    const { path, value } = useFieldPropsV2();
    const mountedFieldRef = useRef({
        path,
        value,
        registry
    });
    useEffect(()=>{
        const field = mountedFieldRef.current;
        const domValue = ref.current?.value;
        if (field.registry && domValue && isEmptyInputValue(field.value)) {
            field.registry.current.set(field.path, domValue);
        }
    }, [
        ref
    ]);
};

//# sourceMappingURL=prehydration-values-context.js.map